class ArticleBibliography {
	private bibliography: HTMLElement | null
	private bibliographyList: HTMLElement | null | undefined
	private bibliographyButton: HTMLElement | null | undefined

	constructor() {
		this.bibliography = document.querySelector('.articleBibliography')
		this.bibliographyList = this.bibliography?.querySelector('.articleBibliography-list')
		this.bibliographyButton = this.bibliography?.querySelector('.articleBibliography-btn')

		this.onBibliographyButtonClick = this.onBibliographyButtonClick.bind(this)
	}

	init() {
		this.addEvents()
	}

	addEvents() {
		this.bibliographyButton?.addEventListener('click', this.onBibliographyButtonClick)
	}

	onBibliographyButtonClick() {
		this.bibliographyList?.classList.toggle('hidden')
	}
}

export default ArticleBibliography
